import { render, staticRenderFns } from "./StutoryBonus.vue?vue&type=template&id=ec5bd3e0&scoped=true"
import script from "./StutoryBonus.vue?vue&type=script&lang=js"
export * from "./StutoryBonus.vue?vue&type=script&lang=js"
import style0 from "./StutoryBonus.vue?vue&type=style&index=0&id=ec5bd3e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5bd3e0",
  null
  
)

export default component.exports